// A random RFC 4122 version-4 id. crypto.randomUUID only exists from iOS
// Safari 15.4, and the site photo composer calls this while rendering — so on
// an older field phone it would crash the whole posting sheet (review of #560).
// crypto.getRandomValues has been around far longer; build the id from that.

export function randomId(): string {
  const c = globalThis.crypto;
  if (typeof c?.randomUUID === 'function') return c.randomUUID();
  const b = new Uint8Array(16);
  c.getRandomValues(b);
  b[6] = (b[6] & 0x0f) | 0x40; // version 4
  b[8] = (b[8] & 0x3f) | 0x80; // RFC 4122 variant
  const h = Array.from(b, (x) => x.toString(16).padStart(2, '0')).join('');
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}
